// extracted by mini-css-extract-plugin
export default {"patient":"UndischargeConfirmationModal_patient__y0Ybu"};